import type { documents as en } from '@/i18n/locales/en/documents';
import type { Translation } from '@/i18n/types';

export const documents: Translation<typeof en> = {
  page: {
    title: 'Belgeler',
    lead: '{{company}} için belge yükleyin ve yönetin.',
    noScope: 'Belgelerini görmek için bir şirket seçin.',
    forbidden: 'Bu şirketin belgelerini görmenize izin verilmiyor.',
  },
  upload: {
    title: 'Belge yükle',
    titleField: 'Başlık',
    category: 'Kategori',
    audience: 'Hedef kitle',
    fileUrl: 'Dosya URL’si',
    file: 'Dosya',
    upload_status: {
      uploading: 'Yükleniyor…',
      tooLarge: 'Dosya çok büyük (maks. 10MB).',
      invalidType: 'Dosya türüne izin verilmiyor.',
    },
    fileUrlHint: 'Hemen yüklenir; veya aşağıya mevcut bir URL girin.',
    requiresReadConfirmation: 'Okuma onayı gerektir',
    requiresReadConfirmationHint: 'Üyeler bu belgeyi okuduklarını onaylamalıdır.',
    submit: 'Yükle',
  },
  categories: {
    algemeen: 'Genel',
    beleid: 'Politika',
    veiligheid: 'Güvenlik',
    hr: 'İK',
    vitaliteit: 'Canlılık',
  },
  audiences: {
    iedereen: 'Herkes',
    management: 'Yönetim',
    per_afdeling: 'Departmana göre',
    per_locatie: 'Konuma göre',
  },
  status: {
    gepubliceerd: 'Yayınlandı',
    archief: 'Arşivlendi',
  },
  library: {
    title: 'Belge kitaplığı',
    empty: 'Henüz belge yok.',
    totalViews: 'Toplam görüntüleme: {{count}}',
    columns: {
      title: 'Başlık',
      category: 'Kategori',
      views: 'Görüntülemeler',
      status: 'Durum',
    },
  },
  actions: {
    new: 'Belge yükle',
    cancel: 'İptal',
    publish: 'Yayınla',
    archive: 'Arşivle',
  },
};
